import React from 'react';
import { BlurView } from 'expo-blur';
import { createStyles } from '@/contexts/theme-context';
import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet } from 'react-native';

export const SIDEBAR_NAV_FADE_HEIGHT = 8;

/** Softens the bottom edge of the scrolling sidebar nav list. */
export const SidebarNavScrollFade: React.FC = () => {
  const [styles, theme] = useStyles();
  const background = theme.sk.color.bg.primary.default;

  return (
    <BlurView
      experimentalBlurMethod="dimezisBlurView"
      intensity={50}
      pointerEvents="none"
      style={styles.fade}
      tint="default"
    >
      <LinearGradient
        colors={[`${background}00`, background]}
        end={[0, 1]}
        start={[0, 0]}
        style={StyleSheet.absoluteFill}
      />
    </BlurView>
  );
};

const useStyles = createStyles(() => ({
  fade: {
    bottom: 0,
    height: SIDEBAR_NAV_FADE_HEIGHT,
    left: 0,
    position: 'absolute',
    right: 0,
  },
}));
